import menulist from './menulist';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [menulist]
};

export default menuItems;
